import { UtilsString } from "@/utils/utils-string";
import { usuario } from "../dtos/usuario";
import { JwtService } from "./JwtService";

export default class UserService {
  private userName = "user";

  public tipos_permisos = [
    { nombre: "Ayuntamiento", id: 1 },
    { nombre: "Administrador", id: 2 },
    { nombre: "Visualizador de datos", id: 3 },
  ];

  public hasuser() {
    return !UtilsString.IsNullOrWhiteSpace(this.getuser());
  }

  public setuser(user: string) {
    window.localStorage.setItem(this.userName, user);
  }

  public getuser() {
    return window.localStorage.getItem(this.userName);
  }

  public clearuser() {
    window.localStorage.removeItem(this.userName);
  }

  public IsAdmin() {
    return JwtService.jwtIsAdmin();
  }

  public get_id_user_permission(user: usuario): number {
    if (user.is_admin == false && user.solo_datos == false) {
      return 1;
    }

    if (user.is_admin == true && user.solo_datos == false) {
      return 2;
    }

    if (user.is_admin == false && user.solo_datos == true) {
      return 3;
    }
    return 1;
  }
  public get_object_user_permission(user: usuario) {
    return this.tipos_permisos.find(
      (x) => x.id === this.get_id_user_permission(user)
    )!;
  }
}

export const medicalUserService = new UserService();
